import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useIsLoggedIn = () =>
  useSelector((state: RootState) => state.stateevents).isLoggedIn;
